
import { Component, Vue } from "vue-property-decorator";
import SpecialTopicPageTep from "@/template/special/SpecialTopicPage.vue";
@Component
export default class SpecialPage extends SpecialTopicPageTep {}
